/* global oyc */
/* global Modernizr */
/* global Promise */

/**
 * @todo implement function loadLib - introduce new Class/Object therefore
 */
oyc.initAll = async function () {
  oyc.Dependency.loaded.push('initAll');
  if (typeof oyc.AssetLoader === 'object') {
    oyc.AssetLoader.init();
    oyc.Dependency.loaded.push('AssetLoader');
    for (let lib in oyc) {
      const type = typeof oyc[lib];
      switch (type) {
        case 'function':
          if (oyc.Dependency.loaded.indexOf(lib) !== -1) {
            break;
          }
          oyc[lib]();
          oyc.Dependency.loaded.push(lib);
          break;
        case 'object':
          if (typeof oyc[lib].init === 'function' && (!('noAutoLoad' in oyc[lib]) || !oyc[lib].noAutoLoad)) {
            let deps = [];
            if ('dependencies' in oyc[lib]) {
              deps = oyc.Dependency.load(oyc[lib]);
            }
            if (oyc.Dependency.loaded.indexOf(lib) !== -1) {
              break;
            }
            if (0 < deps.length) {
              await Promise.all(deps).then(oyc[lib].init());
              console.log('oyc.initAll - all dependencies loaded', lib);
            } else {
              oyc[lib].init();
            }
          }
          oyc.Dependency.loaded.push(lib);
          break;
      }
    }
  }
  oyc.FormCache.enabled = true;
}

window.addEventListener('pageshow', () => {
  window.assetLoad = window.assetLoad || {};

  $('[media="print"]').attr('media', 'all');

  let requests = [];

  // load slick slider
  requests.push(oyc.AssetLoader.loadAsset('/_assets/bda1ba5cb481e7eb4a0c6d4681a46dce/Js/Vendor/slick.min.js'));

  Promise.all(requests).then(function () {
    oyc.initAll();
  });
});
